import React, {Component} from "react";

class EditStatus extends Component {
	render(){
		return (
			<select {...this.props}>
				<option value={undefined}>--- Edición ---</option>
				<option value={true}>Permitir edición</option>
				<option value={false}>No permitir edición</option>
			</select>
		)
	}
}

export default EditStatus;


// WEBPACK FOOTER //
// ./src/elements/forms/edit_status.jsx